<template>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M8.75 8.5C8.75 9.74264 7.74264 10.75 6.5 10.75C5.25736 10.75 4.25 9.74264 4.25 8.5C4.25 7.25736 5.25736 6.25 6.5 6.25C7.74264 6.25 8.75 7.25736 8.75 8.5ZM9.85506 9.5C9.42479 10.9457 8.08551 12 6.5 12C4.567 12 3 10.433 3 8.5C3 6.567 4.567 5 6.5 5C8.26324 5 9.72194 6.30385 9.96456 8L20 8V9.5L9.85506 9.5ZM16.5 18.75C15.2574 18.75 14.25 17.7426 14.25 16.5C14.25 15.2574 15.2574 14.25 16.5 14.25C17.7426 14.25 18.75 15.2574 18.75 16.5C18.75 17.7426 17.7426 18.75 16.5 18.75ZM13.0354 16H3V17.5H13.1449C13.5752 18.9457 14.9145 20 16.5 20C18.433 20 20 18.433 20 16.5C20 14.567 18.433 13 16.5 13C14.7368 13 13.2781 14.3039 13.0354 16Z"
  />
</template>
